<template>
    <div class="result-box" @click="closeResult" v-if="CARDATA">

        <div class="plate-number">
            <p class="number-edit">
                <span>{{CARDATA.carN}}</span>
                <i class="iconfont icon-edit" @click.stop="editResult"></i>
            </p>
            <p class="close" @click="closeResult"><i class="iconfont icon-cha"></i></p>
        </div>

        <div class="car-location">
            <p>{{CARDATA.poi.FLOOR_NAME}}</p>
            <span class="flag">层</span>
            <p>{{CARDATA.parkN}}</p>
            <span>号车位</span>
        </div>

        <div class="car-data">
            <div class="data-img">
                <img :src="CARDATA.imgUrl" alt="" v-show="CARDATA.imgUrl">
                <div class="picture-null" v-show="!CARDATA.imgUrl">
                    <img src="../../../../../public/images/zanwu.png" alt="">
                    <p>爱车图片不见了</p>
                </div>
            </div>
            <div class="data-list">
                <span>时长</span>
                <p>{{CARDATA.parkT}}</p>

            </div>
            <div class="data-list">
                <span>入场</span>
                <p>{{CARDATA.enterT}}</p>
            </div>
            <div class="data-list">
                <span>位置</span>
                <p>{{CARDATA.address}}</p>
            </div>
        </div>

        <div class="navigation" @click="goNaving(CARDATA.poi)">
            <p>立即导航</p>
        </div>
    </div>
</template>

<script>



export default {

    props: {
        carData:{
            default:'',
        }
    },

    watch:{
        carData(data){
            this.CARDATA= data;
        }
    },

    data() {
        return {
            carImg:true,
            CARDATA:this.carData
        };
    },
    methods:{
        closeResult(){
            this.$emit('childClose',false)
        },

        editResult(){
            this.$emit('childResult',false)
        },

        goNaving(poi){

            this.$router.replace('/map');
            this.$mapStep.type = 'planRoute';
            this.$BRT.$route.enterType ='findCar';
            this.$BRT.$selecte.endPoint = poi;

            if(this.$BRT.ready){

                this.bus.$emit('startAndEnd',{type:2});

            }else{  //防止地图没准备

                this.$BRT.$urlParam.NomapReady = 2;//规划路径

            }

        }
    },
};
</script>

<style scoped lang="less">
    @import "../../../../styles/comm";
    @import "./SearchResult.less";
</style>
